import { Component, OnInit } from '@angular/core';
import { BreadcrumbService } from '../shared/breadcrumb.service';

import { STORAGE_ASSETS_LINK } from 'src/app/constant/constant';
import { yt_video } from '../../../models/video';
import { JsonDataService } from 'src/app/services/json-data.service';
import { ProviderStateService } from 'src/app/services/provider-state.service';
@Component({
    selector: 'app-video-section',
    templateUrl: './video-section.component.html',
    styleUrls: ['./video-section.component.css']
})
export class VideoSectionComponent implements OnInit {
    patientvideos: yt_video[] = [];
    slug: string = "";
    constructor(
        private readonly breadcrumbService: BreadcrumbService,
        private readonly jsonDataService: JsonDataService,
        private readonly providerstateService: ProviderStateService
    ) {
        
    }

    async ngOnInit(): Promise<void> {
        this.slug = this.providerstateService.getProviderSlug();
        this.breadcrumbService.setItems([
            { label: 'Dashboard', routerLink:['/', this.slug, 'patient'] },
            { label: 'Videos' }
        ]);
        await this.getPatientVideoData();
    }
    private async getPatientVideoData() {
        await this.jsonDataService
            .getPatientVideoData()
            .then((result) => {
                if (result.success) {
                    this.patientvideos = result.data.map((ele: yt_video) => {
                        ele.imgsrc = STORAGE_ASSETS_LINK + ele.imgsrc;
                        return ele;
                    });
                }
            });
    }
}
